import { render, staticRenderFns } from "./yellowTitle.vue?vue&type=template&id=c3d8b152&scoped=true"
import script from "./yellowTitle.vue?vue&type=script&lang=js"
export * from "./yellowTitle.vue?vue&type=script&lang=js"
import style0 from "./yellowTitle.vue?vue&type=style&index=0&id=c3d8b152&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3d8b152",
  null
  
)

export default component.exports